import { Box, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { CountingContext } from 'stores/CountingContext'
import { formatDateToLocal } from 'utlis/timeUtils'

export const CountingHeader = () => {
	const { counting: { date_start, store }, itemsCountedTotalAmount } = useContext(CountingContext)

	return (
		<Box display='flex' justifyContent='space-between' alignItems='center' padding='1em' backgroundColor='gray.200' borderRadius='md' gap='1em'>
			<Text><b>Date:</b> {formatDateToLocal(date_start)}</Text>
			<Text><b>Company:</b> {store?.company?.name}</Text>
			<Text><b>Shop:</b> {store?.name}</Text>
			<Text><b>Branch:</b> {store?.code}</Text>
			<Text><b>Amount:</b> { itemsCountedTotalAmount ?? 0 }</Text>
		</Box>
	)
}
